import React, { useState } from 'react';
import './Header.css';
import LoginButton from '../Buttons/Button';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Divider, List, ListItem, ListItemText } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { AWSWrapper } from '../../aws';
import Container from '@material-ui/core/Container';
import { resetUser } from '../../posthog';
import { clearAllChatHistory } from '../../lib/chatApi';


function Header() {
  const [showHamburger, setShowHamburger] = useState(false);

  let history = useHistory();
  
  
  
  function handleShowHamburger() {
    setShowHamburger((prev) => !prev);
  }

  const LogoutHandle = async (e) => {
    e.preventDefault();
  
    localStorage.removeItem('GStoken');
    clearAllChatHistory();
    resetUser();
    const result = await AWSWrapper.logout();
    history.push('/login');
  };
  
  function navigateToFAQ () {
    history.push('/faq');
  }

  function navigateToChat () {
    history.push('/chat');
  }

  function navigateToWhatsNew () {
    history.push('/whats-new');
  }

  function navigateToAlerts () {
    history.push('/team/alerts');
  }

  function navigateToActivity () {
    history.push('/activity');
  }
  
  function HeaderDrawer() {
    return (
      <div className='drawer'>
        <List className="header_navup">
          <ListItem>
            <ListItemText>Genius Sheets</ListItemText>
          </ListItem>
        </List>
        <Divider />
          <List>
            <ListItem button onClick={navigateToFAQ}>
              <ListItemText>FAQ</ListItemText>
            </ListItem>
            <ListItem button onClick={navigateToWhatsNew}>
              <ListItemText>What&apos;s New</ListItemText>
            </ListItem>
          {localStorage.getItem('GStoken') ? (
            <ListItem button onClick={navigateToAlerts}>
              <ListItemText>Alerts</ListItemText>
            </ListItem>
          ) : null}
          {localStorage.getItem('GStoken') ? (
            <ListItem button onClick={navigateToActivity}>
              <ListItemText>Activity</ListItemText>
            </ListItem>
          ) : null}
          {localStorage.getItem('GStoken') ? (
            <ListItem button onClick={navigateToChat}>
              <ListItemText>AI Analyst</ListItemText>
            </ListItem>
          ) : null}
          {localStorage.getItem('GStoken') ? (
            <ListItem button onClick={LogoutHandle}>
              <ListItemText>Logout</ListItemText>
            </ListItem>
          ): null}
        </List>
  
        <Divider />
        <List className="Header_bottomDrawer">
          <ListItem button href="/">
            <LazyLoadImage
              className="Header_bottomDrawerImg"
              alt="UnivyFinance"
              src={require('../../assets/images/logos/GS.png')}
            />
          </ListItem>
        </List>
      </div>
    );
  }
  
  return (
    <>
      <Container className="header-container" maxWidth="lg" align="center" >
        <a href="/" className="header-logo-link"><img src={require('../../assets/images/logos/header-logo.png')}
        alt="" className="header-logo logo-padding"/></a>
        <ul className="header-nav-menu-list" >

          <li onClick={navigateToFAQ} className="header-nav-list-item middle">
            <a className="header-nav-link w-nav-link">FAQ</a>
          </li>
          <li onClick={navigateToWhatsNew} className="header-nav-list-item middle">
            <a className="header-nav-link w-nav-link">What&apos;s New</a>
          </li>
          {localStorage.getItem('GStoken') ? (
          <li onClick={navigateToAlerts} className="header-nav-list-item middle">
            <a className="header-nav-link w-nav-link">Alerts</a>
          </li>
          ) : null}
          {localStorage.getItem('GStoken') ? (
          <li onClick={navigateToActivity} className="header-nav-list-item middle">
            <a className="header-nav-link w-nav-link">Activity</a>
          </li>
          ) : null}
          {localStorage.getItem('GStoken') ? (
          <li onClick={navigateToChat} className="header-nav-list-item middle">
            <a className="header-nav-link w-nav-link">AI Analyst</a>
          </li>
          ) : null}
        </ul>
        <div className="header-right-side">
          {localStorage.getItem('GStoken') ? (
            <a onClick={LogoutHandle} className="header-nav-link hidden-on-tablet w-inline-block logout">
              <div className="line-rounded-icon link-icon-left color-accent-1"></div>
              <div className="link-text">Logout</div>
            </a>
          ) : null}
          <div onClick={handleShowHamburger}className="hamburger-menu-btn btn-primary w-nav-button">
            <div className="hamburger-menu-wrapper">
              <div className="hamburger-menu-bar top"></div>
              <div className="hamburger-menu-bar bottom"></div>
            </div>
            <div className="position-absolute btn-primary-gradient"></div>
          </div>
        </div>
        <div>
        </div>
      </Container>
      {showHamburger && HeaderDrawer()}
    </>
  );
}

export default Header;
